import * as React from 'react';
import {
  Button,
  DrawerHeader,
  Typography,
  DrawerBody,
} from '@one-thd/sui-atomic-components';
import { useDrawer } from '../../../../hooks/use-drawer';
import { INSTANT_CHECKOUT_BUTTON_SUBMISSION } from '../../../../constants/analytics';
import { track } from '../../../../analytics/analytics';
import { useViews } from '../../../../hooks/use-views';

export const InstantCheckoutLeaveEnrollment = () => {
  const { hideDrawer } = useDrawer();
  const { goBack } = useViews();

  const handleFinishEnrollment = () => {
    track(INSTANT_CHECKOUT_BUTTON_SUBMISSION, {
      overlayType: 'youre almost finished',
      action: 'yes finish enrollment',
    });
    goBack();
  };

  const handleDoItLater = () => {
    track(INSTANT_CHECKOUT_BUTTON_SUBMISSION, {
      overlayType: 'youre almost finished',
      action: 'no do it later',
    });
    hideDrawer();
  };

  return (
    <>
      <DrawerHeader title="You're Almost Finished!" onClose={handleDoItLater} />

      <DrawerBody>
        <Typography>
          You can&apos;t shop with Instant Checkout until you set up a payment
          method.
        </Typography>
        <br />
        <Typography weight="bold">
          Do you want to finish enrollment now?
        </Typography>
        <div className="sui-flex sui-gap-2 sui-mt-8">
          <Button fullWidth variant="secondary" onClick={handleDoItLater}>
            No, Do It Later
          </Button>
          <Button fullWidth onClick={handleFinishEnrollment}>
            Yes, Finish Enrollment
          </Button>
        </div>
      </DrawerBody>
    </>
  );
};
